export function getPath(obj, path) {
  return path.split(".").reduce((o, k) => (o == null ? o : o[k]), obj);
}

export function setPath(obj, path, value) {
  const keys = path.split(".");
  let o = obj;
  for (let i = 0; i < keys.length - 1; i++) {
    if (o[keys[i]] == null) o[keys[i]] = /^\d+$/.test(keys[i + 1]) ? [] : {};
    o = o[keys[i]];
  }
  o[keys[keys.length - 1]] = value;
}

export const testid = (path) => path.replace(/[^a-zA-Z0-9]+/g, "-");

export const escapeHtml = (s) =>
  (s ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

const ALLOWED_TAGS = new Set(["B", "STRONG", "I", "EM", "U", "BR", "UL", "OL", "LI"]);

export function sanitizeHtml(html) {
  const docu = new DOMParser().parseFromString(`<div>${html ?? ""}</div>`, "text/html");
  const walk = (node) => {
    [...node.childNodes].forEach((child) => {
      if (child.nodeType !== 1) return;
      if (!ALLOWED_TAGS.has(child.tagName)) {
        child.replaceWith(...child.childNodes);
        walk(node);
        return;
      }
      [...child.attributes].forEach((a) => child.removeAttribute(a.name));
      walk(child);
    });
  };
  walk(docu.body);
  return docu.body.innerHTML;
}
